module.exports = __webpack_public_path__ + "img/icon-ticket-all.623ce684.svg";